import React from 'react'
import Gym1 from '../Images/gym1.jpg';
import Gym2 from '../Images/gym2.jpg';
import Gym3 from '../Images/gym3.webp';
import Gym4 from '../Images/gym4.webp';
import Gym5 from '../Images/gym5.jpg';
import Gym6 from '../Images/gym6.avif';

export const Gallery = () => {
  return (
    <div className='gallery' id='gallery'>
      <h1>Fitness Gallery</h1>

      <div className="gal-container">
        <div className='imgs'>
          <img src={Gym1} alt='' />
          <img src={Gym2} alt='' />
          <img src={Gym3} alt='' />
          <img src={Gym4} alt='' />
          <img src={Gym5} alt='' />
          <img src={Gym6} alt='' />
        </div>
      </div>
      <button className='gal-btn'>View More</button>
    </div>
  )
}
